import { FAKE_SHIPSURANCE_INSURANCE_PROVIDER_ID } from '../../../../../components/data-driven-logo/fake-shipsurance-info';

// NOTE: This does not follow the typical hook naming convention. This is setting up for a soon to be day where we have
// multiple insurance providers we would need to make an API call to retrieve.
const useInsuranceProviders = () => {
  return [
    {
      insuranceProviderId: FAKE_SHIPSURANCE_INSURANCE_PROVIDER_ID,
      minimumFundingAmount: {
        value: 10,
        code: 'USD', // Shipsurance can only be USD
      },
    },
  ];
};

export default useInsuranceProviders;
